import {
  ArrowUpTrayIcon,
  EllipsisHorizontalIcon,
  EyeIcon,
  EyeSlashIcon,
  PlusIcon,
  TrashIcon,
  UserIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import {
  CalendarIcon,
  CheckIcon,
  ChevronLeftIcon,
  TriangleRightIcon,
} from "@radix-ui/react-icons";
import Document from "@tiptap/extension-document";
import Paragraph from "@tiptap/extension-paragraph";
import Placeholder from "@tiptap/extension-placeholder";
import { Text } from "@tiptap/extension-text";
import {
  Content,
  EditorContent,
  Extension,
  JSONContent,
  useEditor,
} from "@tiptap/react";
import clsx from "clsx";
import dayjs from "dayjs";
import { FileSpreadsheetIcon } from "lucide-react";
import Papa from "papaparse";
import { ChangeEvent, useEffect, useState } from "react";
import {
  CustomFieldData,
  CustomFieldSelectData,
  useGetCustomFields,
} from "src/api/CustomFields/custom-fields";
import { PriorityData } from "src/api/Services/Journeys/journeyTemplates";
import { useAddBulkTasksToProject } from "src/api/Services/Tasks/tasks";
import { Button } from "src/components/ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "src/components/ui/command";
import { Dialog, DialogContent } from "src/components/ui/dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "src/components/ui/dropdown-menu";
import InputHeading from "src/components/ui/Headings/InputHeading";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "src/components/ui/popover";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "src/components/ui/select";
import { TextInput } from "src/components/ui/text-input";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "src/components/ui/tooltip";
import { v4 as uuidv4 } from "uuid";
import { getPriorityIcon } from "../../Journeys/Template/TemplateEdit/Stages/TemplateStages";
import { PanelStep } from "../../Projects/NewProject/NewProject";
import {
  PrioritySelectWrapper,
  ProjectTaskDueDateWrapper,
  ProjectTaskerComboboxWrapper,
  StatusSelectWrapper,
  VisibilitySelectWrapper,
} from "../NewTaskForInternalUser";
import {
  BulkTaskCustomFieldValue,
  BulkTaskSelectCustomFieldValue,
  createDefaultTask,
  TaskBase,
  TiptapNode,
  useIsOpen,
  useTaskActions,
  useTaskAddingDependency,
  useTaskAssignee,
  useTaskCustomFields,
  useTaskDependentOn,
  useTaskDescription,
  useTaskDueDate,
  useTaskIsVisible,
  useTaskPriority,
  useTaskProject,
  useTaskRelativeDueDate,
  useTaskStageId,
  useTaskStatus,
  useTaskStep,
  useTaskSubtasks,
  useTaskTitle,
  useTaskVariables,
} from "./bulk-task-creation-store";
import { VariableNode } from "./variable-node";

type Props = {};

export default function BulkTaskCreationDialog({}: Props) {
  const isOpen = useIsOpen();
  const { setIsOpen } = useTaskActions();
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent onPointerDownOutside={(e) => {
          e.preventDefault();
        }} className="flex max-h-[96vh] min-h-[600px] max-w-5xl flex-col gap-0 p-0">
        <div className="border-b border-b-gray-200/70 p-4 px-6 text-sm text-gray-700">
          Bulk Task Creation
        </div>
        <div className="flex flex-1 overflow-auto">
          <StepViewer />
          <Steps />
        </div>
      </DialogContent>
    </Dialog>
  );
}

function StepViewer() {
  const step = useTaskStep();
  return (
    <div className="flex h-full w-60 shrink-0 flex-col">
      <div className="space-y-4 py-5 px-6 text-sm">
        <PanelStep
          step={1}
          title="Add Variables"
          isActive={step === 1}
          isCompleted={step > 1}
        />
        <PanelStep
          step={2}
          title="Configure Task Template"
          isActive={step === 2}
          isCompleted={step > 2}
        />
        <PanelStep
          step={3}
          title="Upload Variable Data"
          isActive={step === 3}
          isCompleted={step > 3}
        />
        {/* <div className="flex items-center gap-2">
          <div
            className={clsx(
              "inline-flex h-[20px] w-[20px] items-center justify-center rounded-full border text-[11px] shadow-sm",
              step >= 1
                ? "border-gray-300 text-gray-800"
                : "border-gray-100 text-gray-400"
            )}
          >
            1
          </div>
          <div
            className={clsx(
              "",
              step >= 1 ? "text-gray-800" : "font-light text-gray-400"
            )}
          >
            Add Variables
          </div>
        </div>
        <div className="flex items-center gap-2">
          <div
            className={clsx(
              "inline-flex h-[20px] w-[20px] items-center justify-center rounded-full border text-[11px] shadow-sm",
              step >= 2
                ? "border-gray-300 text-gray-800"
                : "border-gray-100 text-gray-400"
            )}
          >
            2
          </div>
          <div
            className={clsx(
              "",
              step >= 2 ? "text-gray-800" : "font-light text-gray-400"
            )}
          >
            Configure Template
          </div>
        </div>
        <div className="flex items-center gap-2">
          <div
            className={clsx(
              "inline-flex h-[20px] w-[20px] items-center justify-center rounded-full border text-[11px] shadow-sm",
              step >= 3
                ? "border-gray-300 text-gray-800"
                : "border-gray-100 text-gray-400"
            )}
          >
            3
          </div>
          <div
            className={clsx(
              "",
              step >= 3 ? "text-gray-800" : "font-light text-gray-400"
            )}
          >
            Upload Variable Data
          </div>
        </div> */}
        {/* <div className="flex items-center gap-2">
          <div
            className={clsx(
              "inline-flex h-[20px] w-[20px] items-center justify-center rounded-full border text-[11px] shadow-sm",
              step >= 4
                ? "border-gray-300 text-gray-800"
                : "border-gray-100 text-gray-400"
            )}
          >
            4
          </div>
          <div
            className={clsx(
              "",
              step >= 4 ? "text-gray-800" : "font-light text-gray-400"
            )}
          >
            Review
          </div>
        </div> */}
      </div>
    </div>
  );
}

function Steps() {
  const step = useTaskStep();
  switch (step) {
    case 1:
      return <AddVariables />;
    case 2:
      return <ConfigureTemplate />;
    case 3:
      return <UploadTaskData />;
    // case 4:
    //   return <Review />;
    default:
      return null;
  }
}

function AddVariables() {
  const [variableName, setVariableName] = useState("");
  const [message, setMessage] = useState("Press Enter to add");
  const variables = useTaskVariables();
  const { addVariable, removeVariable, setStep, setIsOpen } = useTaskActions();
  const validateVariableName = (name: string) => {
    // Check if empty
    if (!name) {
      return {
        valid: false,
        message: "Variable name cannot be empty",
      };
    }

    // Check if it starts with a letter
    if (!/^[a-zA-Z]/.test(name)) {
      return {
        valid: false,
        message: "Variable name must start with a letter",
      };
    }

    // Check if it contains only letters and numbers
    if (!/^[a-zA-Z0-9-]+$/.test(name)) {
      return {
        valid: false,
        message: "Variable name must contain only letters and numbers",
      };
    }

    // Check for duplicates
    if (variables.includes(name)) {
      return {
        valid: false,
        message: "Variable name already exists",
      };
    }

    return {
      valid: true,
      message: "Press Enter to add",
    };
  };
  return (
    <div className="flex flex-1 flex-col overflow-auto border-l border-l-gray-200/70">
      <div className="flex-1 overflow-auto pt-6 pb-12">
        <div className="space-y-1 px-8">
          <div className="font-medium">Add Variables</div>
          <div className="max-w-prose text-[13px] font-light text-gray-500">
            Create variables to use in your task template. E.g. If you wanted to
            create 100 tasks with different titles such as Task 1, Task 2, ....
            Task 100, your task template's title would look like "Task
            {` {{task-count}}`}" where <span className="">{`task-count`}</span>{" "}
            is a variable.
          </div>
        </div>
        <div className="mt-6 px-8">
          <div className="flex items-center gap-2">
            <div className="space-y-0.5">
              <InputHeading heading="Name" />
              <TextInput
                value={variableName}
                onChange={(e) => {
                  let value = e.target.value;
                  // remove any starting spaces
                  value = value.trimStart();
                  // replace spaces with hyphens
                  value = value.replace(/\s/g, "-");
                  value = value.toLowerCase();
                  if (value !== variableName) {
                    setVariableName(value);
                    if (message !== "Press Enter to add") {
                      setMessage("Press Enter to add");
                    }
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();

                    const result = validateVariableName(variableName);

                    if (result.valid) {
                      addVariable(variableName);
                      setVariableName("");
                      setMessage("Press Enter to add");
                    } else {
                      setMessage(result.message);
                    }
                  }
                }}
                className="w-60"
              />
              <div
                className={clsx(
                  "flex h-5 items-center text-xs font-light",
                  message === "Press Enter to add"
                    ? "text-gray-500"
                    : "text-red-500"
                )}
              >
                {message}
              </div>
            </div>
            {/* <div className="space-y-0.5">
            <InputHeading heading="Normalization" />
            <div className="flex h-9 w-60 items-center rounded-md bg-gray-100 px-2.5 text-sm">
              {variable.trim().toLowerCase().replace(/\s/g, "_")}
            </div>
            <div className="h-5" />
          </div> */}
            {/* <div className="flex h-[60px] shrink-0 items-end">
            <Button>Add</Button>
          </div> */}
          </div>
          <div className="mt-6">
            <div className="space-y-1">
              <InputHeading heading="Variables" />
              <div className="flex min-h-[100px] flex-wrap gap-1.5 rounded-md bg-gray-50 p-4">
                {variables.map((variable, index) => (
                  <div className="flex h-[26px] items-center gap-0.5 rounded-md border border-primary bg-white pl-2 pr-1 text-[13px] text-primary">
                    <div className="-mt-0.5 leading-none">{variable}</div>
                    <button
                      tabIndex={-1}
                      className="group rounded p-0.5 hover:bg-gray-100"
                      onClick={() => removeVariable(index)}
                    >
                      <XMarkIcon className="h-3 w-3 text-gray-500 group-hover:text-gray-600" />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex w-full items-center justify-end gap-2 border-t border-t-gray-200/70 py-4 px-8">
        <Button
          variant="secondary"
          onClick={() => {
            setIsOpen(false);
          }}
        >
          Cancel
        </Button>
        <Button
          disabled={variables.length === 0}
          onClick={() => {
            setStep(2);
          }}
        >
          Next
        </Button>
      </div>
    </div>
  );
}

function ConfigureTemplate() {
  const { setStep } = useTaskActions();
  const dueDate = useTaskDueDate();
  const assignee = useTaskAssignee();
  const addingDependency = useTaskAddingDependency();
  const dependentOn = useTaskDependentOn();
  const subtasks = useTaskSubtasks();
  const title = useTaskTitle();
  const customFields = useTaskCustomFields();
  const [isAddingSubtask, setIsAddingSubtask] = useState(false);
  return (
    <div className="flex flex-1 flex-col border-l border-l-gray-200/70">
      <div className="flex-1 overflow-auto bg-gray-50/70">
        <div className="px-8 pt-6">
          <div className="font-medium">Configure Task Template</div>
        </div>
        <div className="mx-8 my-7 overflow-auto rounded-lg border-[0.5px] border-gray-300 bg-white px-6 pb-6 shadow-sm">
          <div className="pt-4">
            <TaskTitleWrapper />
          </div>
          {/* <div className='mt-8'>
          <Description />
        </div> */}
          <div className="mt-4 flex items-center gap-1 text-sm">
            {/* <Status /> */}
            <Stage />
            <TaskAssignee />
            <DueDate />
            <Priority />
            <Visibility />
            <TaskOptions
              isAddingSubtask={isAddingSubtask}
              setIsAddingSubtask={setIsAddingSubtask}
            />
          </div>
          {!!customFields?.length && <TaskCustomFields />}
          {!!(subtasks.length || isAddingSubtask) && (
            <div className="mt-4">
              <SubtasksBlock
                isAddingSubtask={isAddingSubtask}
                setIsAddingSubtask={setIsAddingSubtask}
              />
            </div>
          )}
          {/* <div
            className={clsx(
              "pb-6",
              subtasks.length || isAddingSubtask ? "mt-4" : "mt-2"
            )}
          >
            {!(subtasks.length || isAddingSubtask) && (
              <div
                onClick={() => {
                  setIsAddingSubtask(true);
                }}
                className="-mx-1.5 flex h-6 w-fit cursor-pointer items-center rounded-md px-1.5 text-xs font-light text-gray-500 transition-colors hover:text-gray-800"
              >
                Add Subtasks
              </div>
            )}
            
          </div> */}
        </div>
      </div>
      <div className="flex w-full items-center justify-end gap-2 border-t border-t-gray-200/70 py-4 px-8">
        <Button
          variant="secondary"
          onClick={() => {
            setStep(1);
          }}
        >
          Back
        </Button>
        <Button
          // disabled={variables.length === 0}
          disabled={
            addingDependency
              ? !dependentOn._id
              : !dueDate ||
                !assignee?.userType ||
                !title ||
                isJSONContentEmpty(title)
          }
          onClick={() => {
            setStep(3);
          }}
        >
          Next
        </Button>
      </div>
    </div>
  );
}

function TaskOptions({
  setIsAddingSubtask,
  isAddingSubtask,
}: {
  setIsAddingSubtask: (value: boolean) => void;
  isAddingSubtask: boolean;
}) {
  const { data: customFieldsData } = useGetCustomFields("task");
  const customFields = useTaskCustomFields();
  const { setCustomField } = useTaskActions();
  const subtasks = useTaskSubtasks();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={"secondary"} className={clsx("h-8 w-8 p-0")}>
          <EllipsisHorizontalIcon className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-44" align="end">
        {!isAddingSubtask && !subtasks.length && (
          <DropdownMenuItem
            onClick={() => {
              setIsAddingSubtask(true);
            }}
          >
            Add Subtasks
          </DropdownMenuItem>
        )}
        <DropdownMenuSub>
          <DropdownMenuSubTrigger
            disabled={customFieldsData?.length === customFields?.length}
          >
            Add Field
          </DropdownMenuSubTrigger>
          <DropdownMenuPortal>
            <DropdownMenuSubContent>
              {customFieldsData
                ?.filter(
                  (field) => !customFields?.find((f) => f._id === field._id)
                )
                .map((field) => (
                  <DropdownMenuItem
                    key={field._id}
                    onClick={() => {
                      if (field.type === "text") {
                        setCustomField({
                          _id: field._id,
                          type: field.type,
                          value: null,
                        });
                      } else if (field.type === "select") {
                        setCustomField({
                          _id: field._id,
                          type: field.type,
                          value: null,
                        });
                      }
                    }}
                  >
                    {field.name}
                  </DropdownMenuItem>
                ))}
            </DropdownMenuSubContent>
          </DropdownMenuPortal>
        </DropdownMenuSub>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

function TaskCustomFields() {
  const customFields = useTaskCustomFields();
  const [expanded, setExpanded] = useState(true);
  return (
    <div className="mt-2 rounded-md border-[0.5px] border-gray-200 p-4 py-2 text-sm shadow-sm">
      <div
        className="group -mx-2 inline-flex h-6 cursor-pointer items-center rounded px-2"
        onClick={() => {
          setExpanded((e) => !e);
        }}
      >
        <div className="text-xs font-light text-gray-600 group-hover:text-gray-800">
          Fields
        </div>
        <div className="ml-1.5 mr-1.5 flex h-4 min-w-[14px] items-center justify-center rounded bg-gray-100 text-[10px]">
          {customFields?.length}
        </div>
        <TriangleRightIcon
          className={clsx(
            "h-3 w-3 text-gray-500 transition-all group-hover:text-gray-800",
            expanded ? "rotate-90" : ""
          )}
        />
      </div>
      {expanded && (
        <div className="my-2 space-y-1">
          {customFields?.map((customFieldValue) => (
            <CustomField
              customFieldValue={customFieldValue}
              key={customFieldValue._id}
            />
          ))}
        </div>
      )}
    </div>
  );
}

function CustomField({
  customFieldValue,
}: {
  customFieldValue: BulkTaskCustomFieldValue;
}) {
  const { removeCustomField } = useTaskActions();
  const { data: customFields } = useGetCustomFields("task");
  const customField = customFields?.find((f) => f._id === customFieldValue._id);
  const [optionsOpen, setOptionsOpen] = useState(false);
  if (!customField) return null;
  return (
    <div className="group flex items-center">
      <div className="w-40 text-[13px] text-gray-700">
        {customFields?.find((f) => f._id === customField._id)?.name}
      </div>
      <CustomFieldValue
        customField={customField}
        customFieldValue={customFieldValue}
      />

      <DropdownMenu open={optionsOpen} onOpenChange={setOptionsOpen}>
        <DropdownMenuTrigger asChild>
          <Button
            variant={"ghost"}
            className={clsx(
              "ml-4 h-8 w-8 p-0",
              optionsOpen ? "bg-gray-100" : ""
            )}
          >
            <EllipsisHorizontalIcon className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-44" align="end">
          <DropdownMenuItem
            // className="py-1 focus:bg-gray-50 focus:text-red-600"
            className="focus:bg-red-50 focus:text-red-600"
            onClick={(e) => {
              removeCustomField(customFieldValue._id);
            }}
          >
            <TrashIcon className="h-3.5 w-3.5 shrink-0" />
            <span className="ml-2 text-sm">Delete</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}

function CustomFieldValue({
  customField,
  customFieldValue,
}: {
  customField: CustomFieldData;
  customFieldValue: BulkTaskCustomFieldValue;
}) {
  switch (customField.type) {
    case "text":
      return (
        <TextCustomFieldValue
          customFieldValue={customFieldValue}
          customField={customField}
        />
      );
    case "select":
      return (
        <SelectCustomFieldValue
          customFieldValue={customFieldValue as BulkTaskSelectCustomFieldValue}
          customField={customField}
        />
      );
    default:
      return null;
  }
}

function SelectCustomFieldValue({
  customField,
  customFieldValue,
}: {
  customField: CustomFieldSelectData;
  customFieldValue: BulkTaskSelectCustomFieldValue;
}) {
  const [open, setOpen] = useState(false);
  const { setCustomField } = useTaskActions();
  return (
    <Select
      open={open}
      onOpenChange={setOpen}
      value={customFieldValue.value ?? undefined}
      onValueChange={(v) => {
        setCustomField({
          _id: customField._id,
          type: "select",
          value: v === "sero-none" ? null : v,
        });
      }}
    >
      <SelectTrigger
        showIcon={false}
        className={clsx(
          "[data-placeholder]:text-gray-300 -mx-2.5 h-9 w-72 border-none px-2.5 shadow-none hover:bg-gray-50",
          open && "bg-gray-50"
        )}
      >
        <SelectValue
          placeholder={<span className="text-gray-300">Select...</span>}
        />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="sero-none" className="text-gray-500">
          None
        </SelectItem>
        {customField.options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

function TextCustomFieldValue({
  customField,
  customFieldValue,
}: {
  customField: CustomFieldData;
  customFieldValue: BulkTaskCustomFieldValue;
}) {
  const { setCustomField } = useTaskActions();
  const editor = useEditor({
    extensions: [
      InlineDoc,
      DisableEnter,
      Paragraph,
      Text,
      VariableNode.configure({
        variables: [...useTaskVariables()],
      }),
      Placeholder.configure({
        placeholder: "Enter text...",
      }),
    ],
    content: customFieldValue.value || "",
    autofocus: true,
    onUpdate() {
      setCustomField({
        _id: customField._id,
        type: "text",
        value: editor?.getJSON() as TiptapNode,
      });
    },
  });
  return (
    <div className="[&_.ProseMirror]:overflow-hidden [&_.ProseMirror]:text-ellipsis [&_.ProseMirror]:whitespace-nowrap">
      <EditorContent
        editor={editor}
        className={
          "-mx-2.5 flex h-9 w-72 items-center rounded-md px-2.5 placeholder:text-gray-300 hover:bg-gray-50 focus:bg-gray-50 focus:outline-none "
        }
      />
    </div>
  );
}

// Subtask Custom Fields

function SubtaskCustomFields({ subtask }: { subtask: TaskBase }) {
  const [expanded, setExpanded] = useState(true);
  const customFields = subtask.customFields;
  if (!customFields) return null;
  return (
    <div className="mt-2 rounded-md border-[0.5px] border-gray-200 bg-white/90 p-4 py-2 text-sm shadow-sm">
      <div
        className="group -mx-2 inline-flex h-6 cursor-pointer items-center rounded px-2"
        onClick={() => {
          setExpanded((e) => !e);
        }}
      >
        <div className="text-xs font-light text-gray-600 group-hover:text-gray-800">
          Fields
        </div>
        <div className="ml-1.5 mr-1.5 flex h-4 min-w-[14px] items-center justify-center rounded bg-gray-100 text-[10px]">
          {customFields?.length}
        </div>
        <TriangleRightIcon
          className={clsx(
            "h-3 w-3 text-gray-500 transition-all group-hover:text-gray-800",
            expanded ? "rotate-90" : ""
          )}
        />
      </div>
      {expanded && (
        <div className="my-2 space-y-1">
          {customFields?.map((customFieldValue) => (
            <SubtaskCustomField
              subtask={subtask}
              customFieldValue={customFieldValue}
              key={customFieldValue._id}
            />
          ))}
        </div>
      )}
    </div>
  );
}

function SubtaskCustomField({
  customFieldValue,
  subtask,
}: {
  customFieldValue: BulkTaskCustomFieldValue;
  subtask: TaskBase;
}) {
  const { updateSubtask } = useTaskActions();
  const { data: customFields } = useGetCustomFields("task");
  const customField = customFields?.find((f) => f._id === customFieldValue._id);
  const [optionsOpen, setOptionsOpen] = useState(false);
  if (!customField) return null;
  return (
    <div className="group flex items-center">
      <div className="w-40 text-[13px] text-gray-700">
        {customFields?.find((f) => f._id === customField._id)?.name}
      </div>
      <SubtaskCustomFieldValue
        subtask={subtask}
        customField={customField}
        customFieldValue={customFieldValue}
      />

      <DropdownMenu open={optionsOpen} onOpenChange={setOptionsOpen}>
        <DropdownMenuTrigger asChild>
          <Button
            variant={"ghost"}
            className={clsx(
              "ml-4 h-8 w-8 p-0",
              optionsOpen ? "bg-gray-100" : ""
            )}
          >
            <EllipsisHorizontalIcon className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-44" align="end">
          <DropdownMenuItem
            // className="py-1 focus:bg-gray-50 focus:text-red-600"
            className="focus:bg-red-50 focus:text-red-600"
            onClick={(e) => {
              updateSubtask(subtask._id, {
                customFields: subtask.customFields?.filter(
                  (cf) => cf._id !== customFieldValue._id
                ),
              });
            }}
          >
            <TrashIcon className="h-3.5 w-3.5 shrink-0" />
            <span className="ml-2 text-sm">Delete</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}

function SubtaskCustomFieldValue({
  customField,
  customFieldValue,
  subtask,
}: {
  customField: CustomFieldData;
  customFieldValue: BulkTaskCustomFieldValue;
  subtask: TaskBase;
}) {
  switch (customField.type) {
    case "text":
      return (
        <SubtaskTextCustomFieldValue
          customFieldValue={customFieldValue}
          customField={customField}
          subtask={subtask}
        />
      );
    case "select":
      return (
        <SubtaskSelectCustomFieldValue
          customFieldValue={customFieldValue as BulkTaskSelectCustomFieldValue}
          customField={customField}
          subtask={subtask}
        />
      );
    default:
      return null;
  }
}

function SubtaskSelectCustomFieldValue({
  customField,
  customFieldValue,
  subtask,
}: {
  customField: CustomFieldSelectData;
  customFieldValue: BulkTaskSelectCustomFieldValue;
  subtask: TaskBase;
}) {
  const [open, setOpen] = useState(false);
  const { updateSubtask } = useTaskActions();
  return (
    <Select
      open={open}
      onOpenChange={setOpen}
      value={customFieldValue.value ?? undefined}
      onValueChange={(v) => {
        updateSubtask(subtask._id, {
          customFields: subtask.customFields?.map((cf) =>
            cf._id === customFieldValue._id && cf.type === "select"
              ? {
                  ...cf,
                  value: v === "sero-none" ? null : v,
                }
              : cf
          ),
        });
      }}
    >
      <SelectTrigger
        showIcon={false}
        className={clsx(
          "[data-placeholder]:text-gray-300 -mx-2.5 h-9 w-72 border-none px-2.5 shadow-none hover:bg-gray-50",
          open && "bg-gray-50"
        )}
      >
        <SelectValue
          placeholder={<span className="text-gray-300">Select...</span>}
        />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="sero-none" className="text-gray-500">
          None
        </SelectItem>
        {customField.options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

function SubtaskTextCustomFieldValue({
  customField,
  customFieldValue,
  subtask,
}: {
  customField: CustomFieldData;
  customFieldValue: BulkTaskCustomFieldValue;
  subtask: TaskBase;
}) {
  const { updateSubtask } = useTaskActions();
  const editor = useEditor({
    extensions: [
      InlineDoc,
      DisableEnter,
      Paragraph,
      Text,
      VariableNode.configure({
        variables: [...useTaskVariables()],
      }),
      Placeholder.configure({
        placeholder: "Enter text...",
      }),
    ],
    content: customFieldValue.value || "",
    autofocus: true,
    onUpdate() {
      updateSubtask(subtask._id, {
        customFields: subtask.customFields?.map((cf) =>
          cf._id === customFieldValue._id && cf.type === "text"
            ? {
                ...cf,
                value: editor?.getJSON() ?? null,
              }
            : cf
        ),
      });
    },
  });
  return (
    <div className="[&_.ProseMirror]:overflow-hidden [&_.ProseMirror]:text-ellipsis [&_.ProseMirror]:whitespace-nowrap">
      <EditorContent
        editor={editor}
        className={
          "-mx-2.5 flex h-9 w-72 items-center rounded-md px-2.5 placeholder:text-gray-300 hover:bg-gray-50 focus:bg-gray-50 focus:outline-none "
        }
      />
    </div>
  );
}

function SubtasksBlock({
  isAddingSubtask,
  setIsAddingSubtask,
}: {
  isAddingSubtask: boolean;
  setIsAddingSubtask: (value: boolean) => void;
}) {
  const subtasks = useTaskSubtasks();
  const { updateSubtask } = useTaskActions();
  const [editingSubtaskId, setEditingSubtaskId] = useState<string | null>(null);

  if (subtasks.length === 0 && !isAddingSubtask) return null;
  return (
    <>
      {isAddingSubtask && (
        <NewSubtask setIsAddingSubtask={setIsAddingSubtask} />
      )}
      {!isAddingSubtask && (
        <>
          {!editingSubtaskId ? (
            <Subtasks
              setIsAddingSubtask={setIsAddingSubtask}
              setEditingSubtaskId={setEditingSubtaskId}
            />
          ) : (
            <EditingSubtaskBlock
              subtaskId={editingSubtaskId}
              setEditingSubtaskId={setEditingSubtaskId}
            />
          )}
        </>
      )}
    </>
  );
}

function EditingSubtaskBlock({
  subtaskId,
  setEditingSubtaskId,
}: {
  subtaskId: string;
  setEditingSubtaskId: (value: string | null) => void;
}) {
  const subtasks = useTaskSubtasks();
  const subtask = subtasks.find((subtask) => subtask._id === subtaskId);

  if (!subtask) {
    return <div>Error</div>;
  }

  return (
    <div className="rounded-md border-[0.5px] border-gray-200 bg-gray-50 shadow-sm">
      <div className="flex h-9 items-center justify-between border-b-[0.5px] border-gray-200 px-3.5">
        <div
          onClick={() => {
            setEditingSubtaskId(null);
          }}
          className="flex cursor-pointer items-center gap-1 text-xs font-light text-gray-500 transition-colors hover:text-gray-800"
        >
          <ChevronLeftIcon className="h-3 w-3" />
          <div>Back to Subtasks</div>
        </div>
      </div>
      <EditingSubtask
        subtask={subtask}
        setEditingSubtaskId={setEditingSubtaskId}
      />
    </div>
  );
}

function EditingSubtask({
  subtask,
  setEditingSubtaskId,
}: {
  subtask: TaskBase;
  setEditingSubtaskId: (value: string | null) => void;
}) {
  // const [newSubtask, setNewSubtask] = useState(createDefaultTask());
  const { data: customFieldsData } = useGetCustomFields("task");
  const { updateSubtask, removeSubtask } = useTaskActions();
  const project = useTaskProject();
  return (
    <div className="px-3.5 pb-3">
      <div className="mt-3">
        <Title
          title={subtask.title}
          setTitle={(title) => {
            updateSubtask(subtask._id, { title });
          }}
          placeholder="Subtask Title..."
          className="text-sm"
        />
      </div>
      <div className="mt-2.5 flex gap-1">
        {/* <StatusSelectWrapper onSelect={() => {}} /> */}
        {project && (
          <ProjectTaskerComboboxWrapper
            disabled={!project}
            projectId={project._id}
            tasker={subtask.assignee}
            onTaskerSelect={(tasker) => {
              if (tasker?.type === "external") {
                updateSubtask(subtask._id, {
                  isVisible: true,
                  assignee: tasker,
                });
              } else {
                updateSubtask(subtask._id, {
                  assignee: tasker,
                });
              }
            }}
          />
        )}
        <NewSubtaskDueDate
          subtask={subtask}
          setSubtask={(subtask) => {
            updateSubtask(subtask._id, subtask);
          }}
        />
        <PrioritySelectWrapper
          onPriorityChange={(value) => {
            if (value === "no-priority") {
              updateSubtask(subtask._id, {
                priority: undefined,
              });
              return;
            }
            updateSubtask(subtask._id, {
              priority: value as PriorityData,
            });
          }}
          priority={subtask.priority}
        />
        <VisibilitySelectWrapper
          onVisibilitySelect={(value) => {
            updateSubtask(subtask._id, {
              isVisible: value,
            });
          }}
          isVisible={subtask.isVisible}
          disabled={subtask.assignee?.type === "external"}
        />
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant={"secondary"} className={clsx("h-8 w-8 p-0")}>
              <EllipsisHorizontalIcon className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="w-44" align="end">
            <DropdownMenuSub>
              <DropdownMenuSubTrigger
                disabled={
                  customFieldsData?.length === subtask.customFields?.length
                }
              >
                Add Field
              </DropdownMenuSubTrigger>
              <DropdownMenuPortal>
                <DropdownMenuSubContent>
                  {customFieldsData
                    ?.filter(
                      (field) =>
                        !subtask.customFields?.find((f) => f._id === field._id)
                    )
                    .map((field) => (
                      <DropdownMenuItem
                        key={field._id}
                        onClick={() => {
                          if (field.type === "text") {
                            updateSubtask(subtask._id, {
                              customFields: [
                                ...(subtask.customFields ?? []),
                                {
                                  _id: field._id,
                                  type: field.type,
                                  value: null,
                                },
                              ],
                            });
                          } else if (field.type === "select") {
                            updateSubtask(subtask._id, {
                              customFields: [
                                ...(subtask.customFields ?? []),
                                {
                                  _id: field._id,
                                  type: field.type,
                                  value: null,
                                },
                              ],
                            });
                          }
                        }}
                      >
                        {field.name}
                      </DropdownMenuItem>
                    ))}
                </DropdownMenuSubContent>
              </DropdownMenuPortal>
            </DropdownMenuSub>
            <DropdownMenuItem
              // className="py-1 focus:bg-gray-50 focus:text-red-600"
              className="focus:bg-red-50 focus:text-red-600"
              onClick={(e) => {
                removeSubtask(subtask._id);
                setEditingSubtaskId(null);
              }}
            >
              <TrashIcon className="h-3.5 w-3.5 shrink-0" />
              <span className="ml-2 text-sm">Delete</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      {!!subtask.customFields?.length && (
        <SubtaskCustomFields subtask={subtask} />
      )}
    </div>
  );
}

function Subtasks({
  setIsAddingSubtask,
  setEditingSubtaskId,
}: {
  setIsAddingSubtask: (addingSubtasks: boolean) => void;
  setEditingSubtaskId: (subtaskId: string | null) => void;
}) {
  return (
    <div className="overflow-hidden rounded-md border-[0.5px] border-gray-200 bg-gray-50 shadow-sm">
      <div className="flex h-9 items-center justify-between border-b-[0.5px] border-gray-200 px-3.5">
        <div className="text-xs font-light text-gray-500">Subtasks</div>
        <Button
          variant={"ghost"}
          className="h-6 w-6 rounded p-0"
          onClick={() => {
            setIsAddingSubtask(true);
          }}
        >
          <PlusIcon className="h-[13px] w-[13px]" />
        </Button>
      </div>
      <SubtasksList setEditingSubtaskId={setEditingSubtaskId} />
      {/* <div className=""></div> */}
    </div>
  );
}

function SubtasksList({
  setEditingSubtaskId,
}: {
  setEditingSubtaskId: (subtaskId: string | null) => void;
}) {
  const subtasks = useTaskSubtasks();
  return (
    <div className="">
      {subtasks.map((subtask, index) => {
        return (
          <SubtaskListItem
            key={subtask._id}
            subtask={subtask}
            isLast={index === subtasks.length - 1}
            setEditingSubtaskId={setEditingSubtaskId}
          />
        );
      })}
    </div>
  );
}

function ReadOnlySubtaskTitle({ title }: { title: TiptapNode }) {
  const editor = useEditor({
    extensions: [
      InlineDoc,
      DisableEnter,
      Paragraph,
      Text,
      VariableNode.configure({
        variables: [...useTaskVariables()],
      }),
      // Placeholder.configure({
      //   placeholder,
      // }),
    ],
    editable: false,
    content: title,
  });
  return (
    <div className="max-w-md [&_.ProseMirror]:overflow-hidden [&_.ProseMirror]:text-ellipsis [&_.ProseMirror]:whitespace-nowrap">
      <EditorContent editor={editor} className="text-sm" />
    </div>
  );
}

function SubtaskListItem({
  subtask,
  isLast,
  setEditingSubtaskId,
}: {
  subtask: TaskBase;
  isLast?: boolean;
  setEditingSubtaskId: (subtaskId: string | null) => void;
}) {
  return (
    <div
      onClick={() => setEditingSubtaskId(subtask._id)}
      className={clsx(
        "cursor-pointer px-3.5 pl-4 pb-3.5 pt-2 text-sm hover:bg-gray-100",
        !isLast ? "border-b-[0.5px] border-gray-200" : ""
      )}
    >
      <div className="h-5">
        {subtask.title && <ReadOnlySubtaskTitle title={subtask.title} />}
      </div>
      <div className="mt-2 flex h-6 items-center gap-1 text-gray-600">
        <div className="inline-flex h-6 items-center gap-1.5 rounded-md border bg-white pl-1.5 pr-2 text-xs shadow-sm">
          <UserIcon className="h-3 w-3" />
          <div>
            {subtask.assignee?.userType === "fullUser"
              ? subtask.assignee.name
              : subtask.assignee?.email}
          </div>
        </div>
        <div className="inline-flex h-6 items-center gap-1.5 rounded-md border bg-white pl-2 pr-2 text-xs shadow-sm">
          <CalendarIcon className="h-3 w-3" />
          <div>
            {!subtask.isAddingDependency
              ? dayjs(subtask.dueDate).format("MMM DD")
              : subtask.dependentOn.type === "task"
              ? "Dependent on task"
              : subtask.dependentOn.type === "stage"
              ? "Dependent on stage"
              : subtask.dependentOn.type === "futureTask"
              ? "Dependent on sibling task"
              : ""}
          </div>
        </div>
        {subtask.priority && (
          <div className="inline-flex h-6 items-center gap-1.5 rounded-md border bg-white pl-2 pr-2 text-xs shadow-sm">
            {getPriorityIcon(subtask.priority, 12)}
            <div>
              {subtask.priority[0].toUpperCase() + subtask.priority.slice(1)}
            </div>
          </div>
        )}
        <div className="inline-flex h-6 items-center gap-1.5 rounded-md border bg-white pl-2 pr-2 text-xs shadow-sm">
          {subtask.isVisible ? (
            <EyeIcon className="h-3 w-3" />
          ) : (
            <EyeSlashIcon className="h-3 w-3" />
          )}
          <div>
            {subtask.isVisible ? "Externally Visible" : "Externally Hidden"}
          </div>
        </div>
        {!!subtask.customFields?.length && (
          <div className="inline-flex h-6 items-center rounded-md border bg-white pl-2 pr-2 text-xs shadow-sm">
            <div>
              {subtask.customFields?.length} Field
              {subtask.customFields?.length === 1 ? "" : "s"}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function isTitleEmpty(title: JSONContent) {
  return title.text === "";
}

function NewSubtask({
  setIsAddingSubtask,
}: {
  setIsAddingSubtask: (addingSubtasks: boolean) => void;
}) {
  const [newSubtask, setNewSubtask] = useState(createDefaultTask());
  const { addSubtask } = useTaskActions();
  const project = useTaskProject();
  console.log(newSubtask);
  return (
    <div className="rounded-md border-[0.5px] border-gray-200 bg-gray-50 shadow-sm">
      <div className="flex h-9 items-center border-b-[0.5px] border-gray-200 px-3.5">
        <div className="text-xs font-light text-gray-500">New Subtask</div>
      </div>
      <div className="px-3.5 pt-3">
        <Title
          title={newSubtask.title}
          setTitle={(title) => {
            setNewSubtask({
              ...newSubtask,
              title,
            });
          }}
          className="text-sm"
          placeholder="Subtask Title..."
        />
      </div>
      <div className="flex gap-1 px-3.5 pt-2.5">
        {/* <StatusSelectWrapper onSelect={() => {}} /> */}
        {project && (
          <ProjectTaskerComboboxWrapper
            disabled={!project}
            projectId={project._id}
            tasker={newSubtask.assignee}
            onTaskerSelect={(tasker) => {
              if (tasker?.type === "external") {
                setNewSubtask({
                  ...newSubtask,
                  isVisible: true,
                  assignee: tasker,
                });
              } else {
                setNewSubtask({
                  ...newSubtask,
                  assignee: tasker,
                });
              }
            }}
          />
        )}
        <NewSubtaskDueDate subtask={newSubtask} setSubtask={setNewSubtask} />
        <PrioritySelectWrapper
          onPriorityChange={(value) => {
            if (value === "no-priority") {
              setNewSubtask({
                ...newSubtask,
                priority: undefined,
              });
              return;
            }
            setNewSubtask({
              ...newSubtask,
              priority: value as PriorityData,
            });
          }}
          priority={newSubtask.priority}
        />
        <VisibilitySelectWrapper
          onVisibilitySelect={(value) => {
            setNewSubtask({
              ...newSubtask,
              isVisible: value,
            });
          }}
          isVisible={newSubtask.isVisible}
          disabled={newSubtask.assignee?.type === "external"}
        />
      </div>
      <div className="flex justify-end gap-1.5 px-3.5 py-3">
        <Button
          size={"sm"}
          onClick={() => {
            setIsAddingSubtask(false);
          }}
          variant={"secondary"}
        >
          Cancel
        </Button>
        <Button
          size={"sm"}
          onClick={() => {
            addSubtask(newSubtask);
            setIsAddingSubtask(false);
          }}
          disabled={
            !newSubtask.title ||
            isTiptapContentEmpty(newSubtask.title) ||
            !newSubtask.assignee ||
            (newSubtask.isAddingDependency
              ? !newSubtask.dependentOn._id
              : !newSubtask.dueDate)
          }
        >
          Create
        </Button>
      </div>
    </div>
  );
}

function Visibility() {
  const { setIsVisible } = useTaskActions();
  const visibility = useTaskIsVisible();
  const subtasks = useTaskSubtasks();
  const assignee = useTaskAssignee();

  if (subtasks.length > 0) {
    const anySubtaskVisible = subtasks.some((subtask) => subtask.isVisible);

    return (
      <TooltipProvider>
        <Tooltip delayDuration={0}>
          <TooltipTrigger>
            <div className="flex h-8 items-center gap-1.5 rounded-md border bg-gray-100 px-2.5">
              {anySubtaskVisible ? (
                <>
                  <EyeIcon className="h-4 w-4 text-gray-500" />
                  <div className="truncate">Externally Visible</div>
                </>
              ) : (
                <>
                  <EyeSlashIcon className="h-4 w-4 text-gray-500" />
                  <div className="truncate">Externally Hidden</div>
                </>
              )}
            </div>
          </TooltipTrigger>
          <TooltipContent>
            <div>Derived from subtasks</div>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }
  return (
    <VisibilitySelectWrapper
      onVisibilitySelect={(value) => {
        setIsVisible(value);
      }}
      isVisible={visibility}
      disabled={assignee?.type === "external"}
    />
  );
}

function Priority() {
  const { setPriority } = useTaskActions();
  const priority = useTaskPriority();
  return (
    <PrioritySelectWrapper
      onPriorityChange={(value) => {
        if (value === "no-priority") {
          setPriority(undefined);
          return;
        }
        setPriority(value as PriorityData);
      }}
      priority={priority}
    />
  );
}

function TaskAssignee() {
  const { setAssignee, setIsVisible } = useTaskActions();
  const assignee = useTaskAssignee();
  const project = useTaskProject();
  return (
    <>
      {project && (
        <ProjectTaskerComboboxWrapper
          disabled={!project}
          projectId={project._id}
          tasker={assignee}
          onTaskerSelect={(tasker) => {
            setAssignee(tasker);
            if (tasker?.type === "external") {
              setIsVisible(true);
            }
          }}
        />
      )}
    </>
  );
}

function NewSubtaskDueDate({
  subtask,
  setSubtask,
}: {
  subtask: TaskBase;
  setSubtask: (subtask: TaskBase) => void;
}) {
  const project = useTaskProject();
  const subtasks = useTaskSubtasks();
  if (!project) {
    return null;
  }

  return (
    <ProjectTaskDueDateWrapper
      dueDate={subtask.dueDate}
      addingDependency={subtask.isAddingDependency}
      dependentOn={subtask.dependentOn}
      onAddingDependencyChange={(value) => {
        setSubtask({
          ...subtask,
          isAddingDependency: value,
        });
      }}
      onDueDateChange={(value) => {
        setSubtask({
          ...subtask,
          dueDate: value,
        });
      }}
      onDependentOnChange={(value) => {
        setSubtask({
          ...subtask,
          dependentOn: value,
        });
      }}
      onRelativeDueDateChange={(value) => {
        setSubtask({
          ...subtask,
          relativeDueDate: value,
        });
      }}
      // TODO: handle tiptap node
      futureTasks={subtasks
        .filter((s) => s._id !== subtask._id)
        .map((s) => ({
          title: s.title ? tiptapContentToText(s.title) : "",
          _id: s._id,
        }))}
      project={project}
      dependencyDisabled={false}
      relativeDueDate={subtask.relativeDueDate}
    />
  );
}

function DueDate() {
  const {
    setDueDate,
    setIsAddingDependency,
    setDependentOn,
    setRelativeDueDate,
  } = useTaskActions();
  const project = useTaskProject();
  const dueDate = useTaskDueDate();
  const addingDependency = useTaskAddingDependency();
  const dependentOn = useTaskDependentOn();
  const relativeDueDate = useTaskRelativeDueDate();
  const subtasks = useTaskSubtasks();
  if (!project) {
    return null;
  }
  // if (subtasks.length > 0) {
  //   return <div>Due date based on subtasks</div>;
  // }

  return (
    <ProjectTaskDueDateWrapper
      dueDate={dueDate}
      addingDependency={addingDependency}
      dependentOn={dependentOn}
      onAddingDependencyChange={setIsAddingDependency}
      onDueDateChange={(value) => {
        setDueDate(value);
      }}
      onDependentOnChange={(value) => {
        setDependentOn(value);
      }}
      onRelativeDueDateChange={(value) => {
        setRelativeDueDate(value);
      }}
      project={project}
      dependencyDisabled={false}
      relativeDueDate={relativeDueDate}
    />
  );
}

function Status() {
  const selectedStatus = useTaskStatus();
  const { setStatus } = useTaskActions();
  return (
    <StatusSelectWrapper
      // statusGroup={useTaskStatusGroup()}
      onSelect={(parentStatus, customStatus) => {
        setStatus({
          name: customStatus,
          parentStatus: parentStatus,
        });
      }}
      // selectedStatus={
      //   selectedStatus
      //     ? {
      //         customStatus: selectedStatus.name,
      //         status: selectedStatus.parentStatus,
      //       }
      //     : undefined
      // }
    />
  );
}

function Stage() {
  const selectedStageId = useTaskStageId();
  const { setStageId } = useTaskActions();
  const project = useTaskProject();
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen} modal={true}>
      <PopoverTrigger asChild>
        <Button
          variant="secondary"
          role="combobox"
          aria-expanded={open}
          className="truncate font-normal"
        >
          {/* <SquareIcon
                    className={clsx(
                      "mr-2 h-3.5 w-3.5 shrink-0",
                      !!selectedStageId ? "text-gray-600" : "text-gray-400"
                    )}
                  /> */}
          {!!selectedStageId ? (
            <div className="max-w-[100px] truncate">
              {project?.stages.find((s) => s._id === selectedStageId)?.name}
            </div>
          ) : (
            <div className="text-gray-400/80">Stage</div>
          )}
          {/* <CaretSortIcon className="ml-2 h-4 w-4 shrink-0 opacity-50" /> */}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        animateOut={false}
        className="pointer-events-auto w-fit min-w-[200px] max-w-[480px] p-0"
        align="start"
      >
        <Command
          filter={(value, search) => {
            if (
              project?.stages
                .find((s) => s._id === value)
                ?.name.toLowerCase()
                .includes(search.toLowerCase())
            ) {
              return 1;
            } else {
              return 0;
            }
          }}
        >
          <CommandInput placeholder="Search stage..." className="h-9" />
          <CommandList>
            <CommandEmpty>No stage found.</CommandEmpty>
            <CommandGroup>
              {project?.stages
                .filter((s) => !s.isUnassigned)
                .map((stage) => (
                  <CommandItem
                    key={stage._id}
                    value={stage._id}
                    onSelect={() => {
                      setStageId(stage._id);
                      setOpen(false);
                    }}
                    className="gap-2"
                  >
                    <span className="truncate">{stage.name}</span>
                    <div className="flex flex-1 shrink-0 items-center justify-end space-x-1">
                      {selectedStageId === stage._id ? (
                        <div
                          className="cursor-pointer rounded-full p-1 transition-all hover:bg-gray-200"
                          onClick={(e) => {
                            e.stopPropagation();
                            setStageId(undefined);
                            setOpen(false);
                          }}
                        >
                          <XMarkIcon
                            className={clsx(
                              "h-2.5 w-2.5 shrink-0",
                              selectedStageId === stage._id
                                ? "opacity-100"
                                : "opacity-0"
                            )}
                          />
                        </div>
                      ) : (
                        <div className="w-5" />
                      )}
                      <CheckIcon
                        className={clsx(
                          "ml-auto h-4 w-4 shrink-0",
                          selectedStageId === stage._id
                            ? "opacity-100"
                            : "opacity-0"
                        )}
                      />
                    </div>
                  </CommandItem>
                ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}

/** keep only the columns the user defined in Step 1 */
const pickVariables = (row: VariableRow, vars: string[]): VariableRow =>
  Object.fromEntries(vars.map((v) => [v, row[v] ?? ""])) as VariableRow;

/** One row from the CSV, keyed by variable name */
export interface VariableRow {
  [variableName: string]: string; // e.g. { "machine-name": "AC-42" }
}

/** What Step 3 returns once the file is parsed */
export interface CsvParseResult {
  tasks: VariableRow[]; // every row that has ≥ 1 variable filled
  taskTitles: string[];
  subtaskTitles: Array<string[]>;
  summary: {
    totalRows: number; // rows in the file (ex - header)
    presentCounts: Record<string, number>; // {"machine-name": 50, …}
    missingVariables: string[]; // variables the user defined but file lacks
  };
}

export function docToInterpolatedText(
  node: TiptapNode,
  row: VariableRow
): string {
  // A. Variable node  ➜  replace with value / fallback / ""
  if (node.type === "variable") {
    const name = node.attrs?.name as string;
    const fallback = node.attrs?.fallback ?? "";
    return row[name] ?? fallback ?? "";
  }

  // B. Plain text node  ➜  return its text
  if (node.type === "text") {
    return node.text ?? "";
  }

  // C. Any container node  ➜  recurse through children
  let out = "";
  if (Array.isArray(node.content)) {
    node.content.forEach((child) => {
      out += docToInterpolatedText(child, row);
    });
  }
  return out;
}

function UploadTaskData() {
  const variables = useTaskVariables();
  const [file, setFile] = useState<File | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [preview, setPreview] = useState<CsvParseResult | null>(null);
  const title = useTaskTitle();
  const subtasks = useTaskSubtasks();
  const assignee = useTaskAssignee();
  const priority = useTaskPriority();
  const journeyStageId = useTaskStageId();
  const addingDependency = useTaskAddingDependency();
  const dependentOn = useTaskDependentOn();
  const relativeDueDate = useTaskRelativeDueDate();
  const project = useTaskProject();
  const dueDate = useTaskDueDate();
  const isVisible = useTaskIsVisible();
  const customFields = useTaskCustomFields();

  const { setStep, setIsOpen } = useTaskActions();
  const addBulkTasksToProjectMutation = useAddBulkTasksToProject();

  const handleFile = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setFile(file);

    Papa.parse<VariableRow>(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results, _file) => {
        const { errors, meta, data } = results;
        if (errors.length) {
          setError("CSV parse error – please check your file.");
          return;
        }

        const headers = meta.fields ?? [];
        const missingVariables = variables.filter((v) => !headers.includes(v));
        if (missingVariables.length) {
          setError(
            `Missing columns: ${missingVariables.join(
              ", "
            )}. Please check your file and try again.`
          );
          return;
        }

        const presentCounts: Record<string, number> = Object.fromEntries(
          variables.map((v) => [v, 0])
        );

        const tasks: VariableRow[] = [];

        data.forEach((row: VariableRow) => {
          let hasAll = true;
          variables.forEach((v) => {
            if (row[v] === undefined || row[v] === "") {
              hasAll = false;
            } else {
              presentCounts[v] += 1;
            }
          });
          if (hasAll) {
            tasks.push(pickVariables(row, variables));
          }
        });

        const result: CsvParseResult = {
          tasks,
          taskTitles: tasks.map((row) => {
            return title ? docToInterpolatedText(title, row) : "";
          }),
          subtaskTitles: tasks.map((row) => {
            return subtasks
              ? subtasks.map((subtask) =>
                  subtask.title ? docToInterpolatedText(subtask.title, row) : ""
                )
              : [];
          }),
          summary: {
            totalRows: data.length,
            presentCounts,
            missingVariables,
          },
        };

        if (result.tasks.length === 0) {
          setError(
            "No valid rows found. Please check your file and try again."
          );
          return;
        }

        setError(null);
        setPreview(result);
        const finalTasks = result.tasks.map((row) => ({
          title: title ? docToInterpolatedText(title, row) : "", // <-- plain string!
          // …other fixed fields you captured (assigneeId, dueDate, etc.)
        }));
        console.log(finalTasks);
      },
    });
  };

  function downloadTemplate() {
    // 1. Header row
    const headerRow = variables.join(","); // e.g. "colA,colB,colC"
  
    // 2. Create one “empty” row with the right number of commas
    const emptyRow = variables.map(() => "").join(","); // e.g. ",,"
  
    // 3. Repeat that 50 times, joining with newlines
    const emptyRows = Array.from({ length: 50 }, () => emptyRow).join("\n");
  
    // 4. Combine into your CSV content
    const csvContent = `${headerRow}\n${emptyRows}\n`;
  
    // 5. Blob + download as before
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "task-variables-template.csv";
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  useEffect(() => {
    if (addBulkTasksToProjectMutation.isSuccess) {
      setIsOpen(false);
    }
  }, [addBulkTasksToProjectMutation.isSuccess]);

  return (
    <div className="flex flex-1 flex-col border-l border-l-gray-200/70">
      <div className="flex-1">
        <div className="space-y-1 px-8 pt-6">
          <div className="font-medium">Upload Variable Data as CSV</div>
        </div>

        <ol className="mt-4 max-w-2xl list-decimal space-y-3 px-8 pl-12 text-sm font-light text-gray-600">
          <li>
            Based on the variables defined in Step 1, we've created a CSV with
            the corresponding columns. Click{" "}
            <span
              onClick={downloadTemplate}
              className="cursor-pointer underline"
            >
              here
            </span>{" "}
            to download it.
          </li>
          <li>
            Add one row for every task. If a variable value is missing in a row,
            we will skip that row.
          </li>
          <li>Upload the CSV below.</li>
        </ol>

        <div className="mt-8 px-8">
          <label className="flex w-full cursor-pointer flex-col items-center justify-center rounded-lg border border-dashed border-gray-300 p-8 py-6 text-center hover:bg-gray-50">
            <ArrowUpTrayIcon className="h-6 w-6 text-gray-400" />
            <span className="mb-1.5 mt-2 text-sm font-semibold">
              Upload CSV
            </span>
            <span className="text-xs font-light text-gray-500">
              Must include columns: {variables.join(", ")}
            </span>

            <input
              type="file"
              accept=".csv,text/csv"
              className="hidden"
              onChange={handleFile}
            />
          </label>
        </div>
        {file && (
          <div className="mx-8 mt-4 flex items-center gap-2 rounded-md bg-gray-100 p-4">
            <FileSpreadsheetIcon className="h-5 w-5 text-green-600" />
            <div>
              <div className="text-sm font-medium">{file.name}</div>
              {/* <div>{file.size} bytes</div> */}
            </div>
          </div>
        )}
        {error && <p className="mt-2 px-8 text-xs text-red-600">{error}</p>}
        {preview && (
          <div className="mt-2 space-y-2 px-8 text-xs text-green-600">
            <span>{preview.tasks.length}</span> out of{" "}
            {preview.summary.totalRows} rows are valid.
          </div>
        )}
      </div>
      <div className="flex w-full items-center justify-end gap-2 border-t border-t-gray-200/70 py-4 px-8">
        <Button
          variant="secondary"
          onClick={() => {
            setStep(2);
          }}
        >
          Back
        </Button>
        <Button
          disabled={
            !preview ||
            !project ||
            preview.tasks.length === 0 ||
            addBulkTasksToProjectMutation.isLoading
          }
          onClick={() => {
            // TODO: Create tasks
            if (!project || !preview) {
              return;
            }
            addBulkTasksToProjectMutation.mutate({
              params: {
                projectId: project._id,
                tasks: preview.taskTitles.map((taskTitle, index) => {
                  // map of old id to new id
                  const subtasksIdMap: Record<string, string> = subtasks.reduce(
                    (acc, subtask) => ({
                      ...acc,
                      [subtask._id]: uuidv4(),
                    }),
                    {}
                  );

                  return {
                    title: taskTitle,
                    _id: uuidv4(),
                    ...(assignee?.userType === "fullUser"
                      ? {
                          taskerId: assignee._id,
                        }
                      : assignee?.userType === "invitedUser"
                      ? {
                          taskerEmail: assignee.email,
                        }
                      : {}),
                    ...(!!assignee
                      ? {
                          taskerType: assignee.type,
                        }
                      : { taskerType: "internal" }),
                    ...(addingDependency && dependentOn._id
                      ? {
                          dependentOn: {
                            _id: dependentOn._id,
                            type:
                              dependentOn.type === "futureTask"
                                ? "task"
                                : dependentOn.type,
                          },
                          relativeDueDate: {
                            unit: relativeDueDate.unit,
                            value: relativeDueDate.value,
                          },
                        }
                      : {
                          dueDate: !!dueDate ? dueDate : undefined,
                        }),
                    isVisible: subtasks.length > 0 ? !!subtasks.find((subtask) => subtask.isVisible) : isVisible,
                    priority: priority,
                    journeyStageId: journeyStageId,
                    customFields: customFields?.map((customField) => ({
                      _id: customField._id,
                      value:
                        customField.type === "text"
                          ? customField.value
                            ? docToInterpolatedText(
                                customField.value,
                                preview.tasks[index]
                              )
                            : ""
                          : customField.value,
                    })),
                    subTasks: subtasks.map((subtask, subtaskIndex) => ({
                      title: preview.subtaskTitles[index][subtaskIndex],
                      _id: subtasksIdMap[subtask._id],
                      ...(subtask.assignee?.userType === "fullUser"
                        ? {
                            taskerId: subtask.assignee._id,
                          }
                        : subtask.assignee?.userType === "invitedUser"
                        ? {
                            taskerEmail: subtask.assignee.email,
                          }
                        : {}),
                      ...(subtask.assignee?.type
                        ? {
                            taskerType: subtask.assignee?.type,
                          }
                        : {
                            taskerType: "internal",
                          }),
                      ...(subtask.isAddingDependency && subtask.dependentOn._id
                        ? {
                            dependentOn: {
                              _id:
                                subtask.dependentOn.type === "futureTask"
                                  ? subtasksIdMap[subtask.dependentOn._id]
                                  : subtask.dependentOn._id,
                              type:
                                subtask.dependentOn.type === "futureTask"
                                  ? "task"
                                  : subtask.dependentOn.type,
                            },
                            relativeDueDate: {
                              unit: subtask.relativeDueDate.unit,
                              value: subtask.relativeDueDate.value,
                            },
                          }
                        : {
                            dueDate: !!subtask.dueDate
                              ? subtask.dueDate
                              : undefined,
                          }),
                      isVisible: subtask.isVisible,
                      priority: subtask.priority,
                      customFields: subtask.customFields?.map((customField) => ({
                        _id: customField._id,
                        value:
                          customField.type === "text"
                            ? customField.value
                              ? docToInterpolatedText(
                                  customField.value,
                                  preview.tasks[index]
                                )
                              : ""
                            : customField.value,
                      }))
                      // journeyStageId: subtask.journeyStageId,
                    })),
                  };
                }),
              },
            });
          }}
        >
          {preview
            ? addBulkTasksToProjectMutation.isLoading
              ? `Creating ${preview.tasks.length} Task${
                  preview.tasks.length === 1 ? "" : "s"
                }...`
              : `Create ${preview.tasks.length} Task${
                  preview.tasks.length === 1 ? "" : "s"
                }`
            : "Create Tasks"}
        </Button>
      </div>
    </div>
  );
}

export const DisableEnter = Extension.create({
  name: "disableEnter",
  addKeyboardShortcuts() {
    return {
      Enter: () => true, // block ↵
      "Shift-Enter": () => true, // block soft-breaks
    };
  },
});

const InlineDoc = Document.extend({
  content: "paragraph", // ← blocks are impossible
});

function SubtaskTitleWrapper({
  title,
  setTitle,
}: {
  title: TiptapNode | undefined;
  setTitle: (title: TiptapNode) => void;
}) {
  return <Title title={title} setTitle={setTitle} />;
}

function TaskTitleWrapper() {
  const title = useTaskTitle();
  const { setTitle } = useTaskActions();
  return <Title title={title} setTitle={setTitle} />;
}

function Title({
  title,
  setTitle,
  placeholder = "Title...",
  className = "",
}: {
  title: TiptapNode | undefined;
  setTitle: (title: TiptapNode) => void;
  placeholder?: string;
  className?: string;
}) {
  const editor = useEditor({
    extensions: [
      InlineDoc,
      DisableEnter,
      Paragraph,
      Text,
      VariableNode.configure({
        variables: [...useTaskVariables()],
      }),
      Placeholder.configure({
        placeholder,
      }),
    ],
    content: title || "",
    autofocus: true,
    onUpdate() {
      setTitle(editor?.getJSON() as TiptapNode);
    },
  });

  useEffect(() => {
    console.log(editor?.getJSON());
  }, [editor?.getJSON()]);

  return <EditorContent editor={editor} className={className} />;
}

function Description() {
  const description = useTaskDescription();
  const { setDescription } = useTaskActions();
  return (
    <textarea
      value={description}
      onChange={(e) => setDescription(e.target.value)}
    />
  );
}

/**
 * Recursively checks a JSONContent node for any non-whitespace text.
 */
function isJSONContentEmpty(node: JSONContent): boolean {
  // Text node: empty if only whitespace or empty
  if (node.type === "text") {
    return !node.text?.trim();
  }

  if (node.type === "variable" && node.attrs?.name) {
    return false;
  }

  // Other node with no children → empty (e.g. `<p></p>`)
  if (!node.content || node.content.length === 0) {
    return true;
  }

  // Otherwise, all children must be empty
  return node.content.every((child) => isJSONContentEmpty(child));
}

/**
 * Returns true if the given Tiptap content (HTML or JSON) has no real text.
 */
export function isTiptapContentEmpty(content: Content): boolean {
  if (content == null) {
    return true;
  }

  // 1) HTML string: strip tags and see if anything non-whitespace remains
  if (typeof content === "string") {
    const textOnly = content.replace(/<[^>]+>/g, "").trim();
    return textOnly === "";
  }

  // 2) Single JSON node
  if (!Array.isArray(content)) {
    return isJSONContentEmpty(content);
  }

  // 3) Array of JSON nodes
  return content.every((node) => isJSONContentEmpty(node));
}

/**
 * Recursively pulls out all `text` fields from a JSONContent node,
 * inserting single spaces between adjacent text chunks.
 */
function extractTextFromJSON(node: JSONContent): string {
  // If this is a text node, return its text (or empty string)
  if (node.type === "text") {
    return node.text ?? "";
  }

  if (node.type === "variable" && node.attrs?.name) {
    // return the rendered placeholder, or just the name if you prefer
    return `{{${node.attrs.name}}}`;
  }

  // Otherwise, walk its children (if any)
  if (Array.isArray(node.content) && node.content.length > 0) {
    return node.content
      .map((child) => extractTextFromJSON(child))
      .filter(Boolean) // drop empty strings
      .join(" ");
  }

  // No text and no children → empty
  return "";
}

/**
 * Convert any Tiptap Content into a plain text string.
 */
export function tiptapContentToText(content: Content): string {
  // 1) Null / undefined → empty
  if (content == null) {
    return "";
  }

  // 2) HTML string → use DOMParser to strip tags
  if (typeof content === "string") {
    // In browser:
    if (typeof window !== "undefined" && "DOMParser" in window) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(content, "text/html");
      return doc.body.textContent?.trim() ?? "";
    }
    // Fallback for non-DOM environments:
    return content
      .replace(/<[^>]+>/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  // 3) Single JSONContent node
  if (!Array.isArray(content)) {
    return extractTextFromJSON(content).trim();
  }

  // 4) Array of JSONContent nodes
  return content
    .map((node) => extractTextFromJSON(node))
    .filter(Boolean)
    .join(" ")
    .trim();
}
